<template>
  <WdsButton data-test="timesheet-import-button" @click="isModalOpen = true">
    {{ $t('Import timesheets') }}
  </WdsButton>
  <TimesheetImportModal :is-open="isModalOpen" @close="isModalOpen = false" />
</template>

<script setup lang="ts">
import { WdsButton } from '@worksome/wds-components'
import { ref } from 'vue'
import TimesheetImportModal from '@/components/TimesheetImport/TimesheetImportModal.vue'
import { useTranslation } from '@/composables/translation'

const isModalOpen = ref(false)

const { $t } = useTranslation()
</script>
